import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ScienceDegreeService } from '../data/science-degree.service';
import { ScienceStatusService } from '../data/science-status.service';
import { SpecialityService } from '../data/speciality.service';
import { forkJoin } from 'rxjs';
import { IKeyValue, sortIKeyValueByName } from 'src/app/models/ikeyvalue.interface';
import { PaymentTypeService } from '../data/payment-type.service';
import { CompanyService } from '../data/company.service';
import { RankService } from '../data/rank.service';
import { AuthService } from '../auth/auth.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class CollectionsService {

  constructor(
    private auth: AuthService,
    private srvScDg: ScienceDegreeService,
    private srvScSt: ScienceStatusService,
    private srvSp: SpecialityService,
    private srvPt: PaymentTypeService,
    private srvCm: CompanyService,
    private srvRk: RankService
  ) {
    this.auth._authState.pipe(
      untilDestroyed(this),
      tap(authorized => {
        this.resetAll(authorized);
      })
    ).subscribe();
  }

  private _isAuth: boolean = false;

  SEX = [
    { label: 'Мужской', value: 'Мужской'}  ,
    { label: 'Женский', value: 'Женский'}  ,
  ];

  SCIENCE_DEGREES: SelectItem[] = [];
  SCIENCE_STATUSES: SelectItem[] = [];
  SPECIALITIES: SelectItem[] = [];
  PAYMENT_TYPES: SelectItem[] = [];
  COMPANIES: SelectItem[] = [];
  RANKS: SelectItem[] = [];

  resetAll(authorized: boolean) {
    const sources = [
      this.srvScDg.getAll(),
      this.srvScSt.getAll(),
      this.srvSp.getAll(),
    ];
    if (authorized) {
      sources.push(this.srvPt.getAll());
      sources.push(this.srvCm.getAll());
      sources.push(this.srvRk.getAll());
    }
    forkJoin(sources).pipe(
      untilDestroyed(this),
      tap( data => {
        this.SCIENCE_DEGREES = data[0].sort(sortIKeyValueByName).map((o: IKeyValue) => ({ label: o.name, value: o.id } as SelectItem));
        this.SCIENCE_STATUSES = data[1].sort(sortIKeyValueByName).map((o: IKeyValue) => ({ label: o.name, value: o.id } as SelectItem));
        this.SPECIALITIES = data[2].sort(sortIKeyValueByName).map((o: IKeyValue) => ({ label: o.name, value: o.id } as SelectItem));
        this.PAYMENT_TYPES = authorized ? data[3].sort(sortIKeyValueByName).map((o: IKeyValue) => ({ label: o.name, value: o.id } as SelectItem)) : [];
        this.COMPANIES =authorized ? data[4].sort(sortIKeyValueByName).map((o: IKeyValue) => ({ label: o.name, value: o.id } as SelectItem)) : [];
        this.RANKS =authorized ? data[5].sort(sortIKeyValueByName).map((o: IKeyValue) => ({ label: o.name, value: o.id } as SelectItem)) : [];
        })
    ).subscribe(

    )
  }
}
